import fetch from 'unfetch';
import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost';
import { setContext } from 'apollo-link-context';

import { headers as httpHeaders } from '../utils/httpUtil';

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...httpHeaders({ useToken: true }),
      ...headers
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(
    new HttpLink({
      uri:
        process.env.NODE_ENV === 'production'
          ? process.env[`${process.env.TENANT}_GRAPHQL_API_URL`]
          : process.env.REACT_APP_GRAPHQL_API_URL,
      fetch: fetch
    })
  ),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  }
});

export default client;
